import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';

import { IListingFilter } from 'src/app/interfaces/listing-filter';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiDataSource } from 'src/app/services/api-data-source.service';
import { DateRange } from '../interfaces/date-range';
import { Event } from '@angular/router';
import { EventApiService } from './event-api-service';
import { Category } from '../interfaces/category';

// @Injectable()
export class EventDataSource extends ApiDataSource {
  constructor(
    protected EventApi: EventApiService,
    private readonly role: string,
    private readonly endpointUrl: any,
    private readonly ListingFilter?: IListingFilter
  ) {
    super();

    !!this.ListingFilter &&
      Object.keys(this.ListingFilter).forEach((key) =>
        this.setFilter(key, this.ListingFilter[key])
      );
  }

  public DateRange: BehaviorSubject<DateRange> = new BehaviorSubject<DateRange>(
    null
  );
  protected Data: BehaviorSubject<Event[]> = new BehaviorSubject([]);

  protected Events: Event[] = [];

  protected loadData(PageEvent: PageEvent) {
    return this.EventApi.listWithPageEvent(
      this.role,
      this.filter.value,
      PageEvent
    );
  }

  public getRole() {
    return this.role;
  }

  public loadWithDateRange(DateRange?: DateRange, PageEvent?: PageEvent) {
    this.loading.next(true);
    this.Data.next([]);

    this.EventApi.listWithDateRange(
      this.role,
      this.endpointUrl,
      this.filter.value,
      DateRange,
      PageEvent
    )
      .then((ResponseBody: IResponseBody) => {
        this.setData(ResponseBody);
        this.PageEvent.next(ResponseBody.pageEvent);
        this.loading.next(false);
      })
      .catch(() => this.loading.next(false));
  }

  protected setData(ResponseBody: IResponseBody) {
    this.Data.next(ResponseBody.data);
  }
}
